<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        :title=title
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/Component/ComponentDetail"
        :parent-component="$options.name"
        @alternate_action="$emit('alternate_action', $event)"
        @embedded_action="onEmbeddedAction($event)"
        :show-select="showSelect"
    >
      <template v-slot:bar>
        <slot name="bar"></slot>
      </template>
      <template v-slot:top>
        <slot name="top"></slot>
      </template>
      <template v-slot:top.bar.filter>
        <slot name="top.bar.filter"></slot>
      </template>
      <template v-slot:item.action="{ item }">
        <slot name="item.action" :item="item">{{ '' }}</slot>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-icon small
                @click="onComponentClick(item.uid)"
                color="edit_icon" class="d-flex justify-center">
            mdi-square-edit-outline
          </v-icon>
      </template>
      <template v-slot:item.category_uid="{ item }">
        <span v-if="!!item.category_uid && !!storeAggregate.rootData[item.category_uid]">
          {{ storeAggregate.rootData[item.category_uid].category }}
        </span>
      </template>
      <template v-slot:item.subcategory_uid="{ item }">
        <span v-if="!!item.subcategory_uid && !!storeAggregate.rootData[item.subcategory_uid]">
          {{ storeAggregate.rootData[item.subcategory_uid].subcategory }}
        </span>
      </template>
      <template v-slot:item.brand_uid="{ item }">
        <span v-if="!!item.brand_uid && !!storeAggregate.rootData[item.brand_uid]">
          {{ storeAggregate.rootData[item.brand_uid].name }}
        </span>
      </template>
      <template v-slot:item.case_package_uid="{ item }">
        <span v-if="!!item.case_package_uid && !!storeAggregate.rootData[item.case_package_uid]">
          {{ storeAggregate.rootData[item.case_package_uid].name }}
        </span>
      </template>
      <template v-slot:item.case_package__case_package_type="{ item }">
        <v-chip
            v-if="!!item.case_package_uid && !!storeAggregate.rootData[item.case_package_uid] && !!storeAggregate.rootData[item.case_package_uid].case_package_type"
            :color="storeAggregate.rootData[item.case_package_uid].case_package_type_color_dict.color"
        >
          {{ storeAggregate.rootData[item.case_package_uid].case_package_type_color_dict.text }}
        </v-chip>
      </template>
      <template v-slot:item.subcategory__category__category="{ item }">
        <span
            v-if="!!item.subcategory_uid && !!storeAggregate.rootData[item.subcategory_uid] && !!storeAggregate.rootData[item.subcategory_uid].category_uid"
        >
          {{ storeAggregate.rootData[storeAggregate.rootData[item.subcategory_uid].category_uid].category }}
        </span>
      </template>
      <template v-slot:item.main_attributes="{ item }">
          {{ item.main_attributes.join(" • ") }}
      </template>
      <template v-slot:item.is_group="{ item }">
        <v-icon v-if="item.is_group" small class="d-flex justify-center">
          mdi-account-group-outline
        </v-icon>
        {{ '' }}
      </template>
      <template v-slot:item.supply_type="{ item }">
        <span v-if="!!item.default_supply_information">
          {{ item.default_supply_information.up_level.default_supply }}
        </span>
      </template>
      <template v-slot:item.image="{item}">
          <BaseImageCard
              v-if="!!item.image"
              v-model="item.image"
              max-height="64"
              max-width="64"
              readonly
          ></BaseImageCard>
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend"></slot>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import BaseImageCard from "@/components/Base/BaseImageCard";
import CommonTaskIcon from "@/components/Common/CommonTaskIcon";
import {useDetailStore} from "@/components/Common/CommonDetail";

export default {
  name: "ComponentTable",

  props: {
    title: {default: null},
    embedded: {default: false},
    height: {default: null},
    headers: {default: null},
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoDetailQuery: {default: 'ComponentDetailQueryDTO'},
    detailStoreName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoListQuery: {type: [String], default: 'ComponentListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ComponentActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
    showSelect: true,
  },

  components: {
    CommonTable,
    // ComponentDetail,
    ComponentDetail: () => import("@/components/CoreComponent/Component/ComponentDetail"),
    BaseImageCard,
    CommonTaskIcon,
  },

  methods: {
    onComponentClick(component_uid) {
      if (component_uid) {
        const routeData = this.$router.resolve({name: 'ComponentDetail', params: {uidItem: component_uid}});
        window.open(routeData.href, '_blank');
      }
    },
    onEmbeddedAction(event) {
      // console.log('onEmbeddedAction', event)
      if (event.actionName === 'embedded_new_article') {
        // console.log('embedded_new_article', event)
        this.storeDetail.uidItem = uuidv4()
        this.storeDetail.dialogDetail = true
      }
      if (event.actionName === 'embedded_new_group') {
        // console.log('embedded_new_group', event)
        this.storeDetail.metadata = {is_group: true}
        this.storeDetail.uidItem = uuidv4()
        this.storeDetail.dialogDetail = true
      }
    },

  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeDetail = useDetailStore(this.detailStoreName)()
    this.storeTable.headers = this.headers || [
      {text: 'S', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 10, type: 'status'},
      {text: 'T', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 10},
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'QA', value: 'check_qa_params', sortable: false, filterable: true, divider: true, type: 'bool', width: 10},
      // {text: 'G', value: 'is_group', sortable: true, filterable: true, divider: true, width: 30, type: 'bool'},
      {text: 'Article', value: 'article_display', sortable: true, filterable: true, divider: true, width: 50},
      {text: 'Alias', value: 'alias', sortable: true, filterable: true, divider: true, width: 150},
      {text: 'MPN', value: 'mpn', sortable: true, filterable: true, divider: true, width: 150},
      {text: 'case_package', value: 'case_package_uid', article_type: true, filterable: true, divider: true, width: 50},
      {text: 'CasePackage type', value: 'case_package__case_package_type', sortable: false, filterable: true, divider: true, width: 50},
      {text: 'subcategory', value: 'subcategory_uid', article_type: true, filterable: true, divider: true, width: 150},
      {text: 'Category', value: 'subcategory__category__category', sortable: true, filterable: true, divider: true, width: 150},
      {text: 'Article parameters', value: 'main_attributes', sortable: true, filterable: true, divider: true, width: 150},
      {text: 'supply_type', value: 'supply_type', sortable: false, filterable: true, divider: true, width: 100},
      {text: 'image', value: 'image', sortable: false, filterable: true, divider: true, width: 100},
      {text: 'description', value: 'description', sortable: false, filterable: true, divider: true, width: 300},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['alias']
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>